import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionLoanPermissions extends BaseScenesPermissions {}

export default EmissionLoanPermissions
